<div class="wrapper" [innerHTML]="value$ | async | printSafeHtml"> </div>
<footer>
  <img src="assets/img/lumeer-poweredby.svg">
</footer>
